import { useState, useCallback, MouseEvent } from 'react';

export const useModal = () => {
  const [open, setOpen] = useState(false);

  const handleShow = useCallback((e?: MouseEvent<HTMLElement>) => {
    e && e.stopPropagation();

    setOpen(true);
  }, []);

  const handleHide = useCallback((e?: MouseEvent<HTMLElement>) => {
    e && e.stopPropagation();
    setOpen(false);
  }, []);

  return { open, show: handleShow, hide: handleHide };
};
